//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/TransientObject.js";
let d=[[[0,"OpenMode",1,0]],[[[],"Dispose",{},0,0],[[],"Load",{},0,0],[["sheetName"],"GetWorksheet",{R_:{worksheet:"Tooling.ExcelWorksheet"}},1,0],[["count","sheetNames"],"ListWorksheets",{},0,0],[["sheetName","afterSheetName"],"CreateWorksheet",{R_:{worksheet:"Tooling.ExcelWorksheet"}},2,0],[[],"Save",{},0,0],[["rangeName","col0","row0","col1","row1"],"GetNamedRange",{R_:{worksheet:"Tooling.ExcelWorksheet"}},1,0],[["rangeName","sheetName","fromCellCoord","toCellCoord"],"SetNamedRange",{},4,0]],[]];
SPLM.Tooling.ExcelManager = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ExcelManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.OpenMode = Object.freeze({
    "Read" : "Read", "Write" : "Write"});

export default SPLM;